import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { RecoverPasswordForm } from './RecoverPasswordForm';
import { useRecoverPassword } from '../../hooks/api/use-authentication.hook';

export const RecoverPassword = () => {
  const navigate = useNavigate();
  const [recoverPassword, { error, loading }] = useRecoverPassword();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm<RecoverPasswordForm>({ resolver: classValidatorResolver(RecoverPasswordForm) });

  const onSubmit: SubmitHandler<RecoverPasswordForm> = async (values) => {
    await recoverPassword(values);
  };

  const renderContent = () => {
    if (error) {
      return <Alert severity="error">{error.response?.data.message}</Alert>;
    } else if (isSubmitSuccessful) {
      return <Alert severity="success">Password reset email sent</Alert>;
    }

    return (
      <>
        <DialogContentText>To reset your password, enter your email below</DialogContentText>
        <TextField
          {...register('email')}
          variant="outlined"
          sx={{ mt: '1rem' }}
          disabled={loading}
          error={Boolean(errors.email)}
          helperText={errors.email?.message}
          label="Email"
          margin="dense"
          size="small"
          fullWidth
        />
      </>
    );
  };

  return (
    <>
      <Dialog open={true}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Reset password</DialogTitle>
          <DialogContent>{renderContent()}</DialogContent>
          <DialogActions>
            <Button disabled={isSubmitting} variant="outlined" onClick={() => navigate('..')} color="primary">
              {isSubmitSuccessful ? 'Close' : 'Cancel'}
            </Button>
            {!isSubmitSuccessful ? (
              <LoadingButton color="primary" type="submit" variant="contained" loading={isSubmitting}>
                Reset Password
              </LoadingButton>
            ) : null}
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};
